Object.defineProperty(exports,"__esModule",{value:true});exports.registerAsset=registerAsset;exports.getAssetByID=getAssetByID;var assets=[];function registerAsset(asset){return assets.push(asset);}function getAssetByID(assetId){return assets[assetId-1];}


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/modules/AssetRegistry/index.js